import type { ReactElement } from 'react'
import React from 'react'
import { IconText } from '@s4l/ds'
import { IconCheckCircle } from '@s4l/icons/IconCheckCircle'
import { IconAirConditioner } from '@s4l/icons/IconAirConditioner'
import { IconWifi } from '@s4l/icons/IconWifi'
import { IconCarPark } from '@s4l/icons/IconCarPark'
import { IconSafeBox } from '@s4l/icons/IconSafeBox'
import { IconShield } from '@s4l/icons/IconShield'
import { IconReceptionist } from '@s4l/icons/IconReceptionist'
import { IconAccessible } from '@s4l/icons/IconAccessible'
import { IconSwimmingPool } from '@s4l/icons/IconSwimmingPool'
import { IconGym } from '@s4l/icons/IconGym'
import { IconSpa } from '@s4l/icons/IconSpa'
import { IconRestaurant } from '@s4l/icons/IconRestaurant'
import { IconTerrace } from '@s4l/icons/IconTerrace'
import { IconTelevision } from '@s4l/icons/IconTelevision'
import { IconKitchen } from '@s4l/icons/IconKitchen'
import { IconHeating } from '@s4l/icons/IconHeating'
import { IconBathroom } from '@s4l/icons/IconBathroom'
import { IconShower } from '@s4l/icons/IconShower'
import { IconFridge } from '@s4l/icons/IconFridge'
import { IconMinibar } from '@s4l/icons/IconMinibar'
import { IconHairdryer } from '@s4l/icons/IconHairdryer'
import { IconGarden } from '@s4l/icons/IconGarden'
import { IconPhone } from '@s4l/icons/IconPhone'
import { IconBreakfast } from '@s4l/icons/IconBreakfast'
import { IconCarpetedFloors } from '@s4l/icons/IconCarpetedFloors'
import { IconCasino } from '@s4l/icons/IconCasino'
import { IconCloakroom } from '@s4l/icons/IconCloakroom'
import { IconCooker } from '@s4l/icons/IconCooker'
import { IconAirportShuttle } from '@s4l/icons/IconAirportShuttle'
import { IconBar } from '@s4l/icons/IconBar'
import { IconBathtub } from '@s4l/icons/IconBathtub'
import { IconBananaBoating } from '@s4l/icons/IconBananaBoating'
import { IconCurrencyExchange } from '@s4l/icons/IconCurrencyExchange'
import { IconDiving } from '@s4l/icons/IconDiving'
import { IconFireplace } from '@s4l/icons/IconFireplace'
import { IconGameRoom } from '@s4l/icons/IconGameRoom'
import { IconHairdressingSalon } from '@s4l/icons/IconHairdressingSalon'
import { IconInternet } from '@s4l/icons/IconInternet'
import { IconIroningSet } from '@s4l/icons/IconIroningSet'
import { IconJetSki } from '@s4l/icons/IconJetSki'
import { IconKeyCollection } from '@s4l/icons/IconKeyCollection'
import { IconLiftAccess } from '@s4l/icons/IconLiftAccess'
import { IconMicrowave } from '@s4l/icons/IconMicrowave'
import { IconMotorBoard } from '@s4l/icons/IconMotorBoard'
import { IconNewspaper } from '@s4l/icons/IconNewspaper'
import { IconNightClub } from '@s4l/icons/IconNightClub'
import { IconRadio } from '@s4l/icons/IconRadio'
import { IconShop } from '@s4l/icons/IconShop'
import { IconSmokeDetector } from '@s4l/icons/IconSmokeDetector'
import { IconTheatre } from '@s4l/icons/IconTheatre'
import { IconWashingMachine } from '@s4l/icons/IconWashingMachine'
import { IconWaterSkiing } from '@s4l/icons/IconWaterSkiing'
import { IconWindsurfing } from '@s4l/icons/IconWindsurfing'
import { IconSingleBed } from '@s4l/icons/IconSingleBed'
import { IconDoubleBed } from '@s4l/icons/IconDoubleBed'

// prettier-ignore
const FACILITY_ICON_MAP: Record<string, ReactElement> = {
    // Featured facilities
    'air-conditioner': <IconAirConditioner />,
    'airplane': <IconAirportShuttle />, 
    'airport-shuttle': <IconAirportShuttle />,
    'parking': <IconCarPark />, 
    'garage': <IconCarPark />, 
    'gym': <IconGym />, 
    'receptionist': <IconReceptionist />, 
    '24-hour-reception': <IconReceptionist />,
    'safe': <IconSafeBox />, 
    'spa': <IconSpa />, 
    'pool': <IconSwimmingPool />, 
    'outdoor': <IconSwimmingPool />, 
    'indoor': <IconSwimmingPool />, 
    'private-pool': <IconSwimmingPool />,
    'wheelchair': <IconAccessible />, 
    'wifi-alt': <IconWifi />,
    'wifi': <IconWifi />, 
    'wi-fi': <IconWifi />,
  
    // Common facilities
    'air-conditioning-in-public-areas': <IconAirConditioner />,
    'centrally-regulated-air-conditioning': <IconAirConditioner />,
    'individually-adjustable-air-conditioning': <IconAirConditioner />,
    'banana-boating': <IconBananaBoating />,
    'bar': <IconBar />, 
    'pub': <IconBar />, 
    'bathroom': <IconBathroom />, 
    'private-external-bathroom': <IconBathroom />,
    'bathtub': <IconBathtub />, 
    'breakfast': <IconBreakfast />, 
    'carpeted-floors': <IconCarpetedFloors />,
    'casino': <IconCasino />, 
    'central-heating': <IconHeating />,
    'individually-adjustable-heating': <IconHeating />,
    'hanger': <IconCloakroom />, 
    'cloakroom': <IconCloakroom />, 
    'cooker': <IconCooker />, 
    'currency-exchange-facilities': <IconCurrencyExchange />,
    'direct-dial-telephone': <IconPhone />,
    'diving': <IconDiving />, 
    'fireplace': <IconFireplace />, 
    'fridge': <IconFridge />, 
    'mini-fridge': <IconFridge />,
    'game-room': <IconGameRoom />,
    'garden': <IconGarden />, 
    'hairdressing-salon': <IconHairdressingSalon />,
    'hairdryer': <IconHairdryer />, 
    'hotel-safe': <IconShield />,
    'internet': <IconInternet />, 
    'ironing-set': <IconIroningSet />,
    'jet-ski': <IconJetSki />,
    'key-collection': <IconKeyCollection />,
    'kitchenette': <IconKitchen />, 
    'lift-access': <IconLiftAccess />,
    'microwave': <IconMicrowave />, 
    'minibar': <IconMinibar />, 
    'motor-board-ride': <IconMotorBoard />,
    'newspaper-stand': <IconNewspaper />,
    'nightclub': <IconNightClub />, 
    'radio': <IconRadio />, 
    'restaurant': <IconRestaurant />, 
    'kitchen-utensils-plates-cups': <IconRestaurant />,
    'shop': <IconShop />, 
    'shower': <IconShower />, 
    'smoke-detector': <IconSmokeDetector />,
    'terrace': <IconTerrace />, 
    'theatre-auditorium': <IconTheatre />,
    'tv': <IconTelevision />, 
    'tv-lounge': <IconTelevision />,
    'launderette': <IconWashingMachine />,
    'laundry': <IconWashingMachine />, 
    'washing-machine': <IconWashingMachine />,
    'laundry-service': <IconWashingMachine />,
    'waterskiing': <IconWaterSkiing />, 
    'windsurfing': <IconWindsurfing />, 
  
    // Beds
    'single-bed-90-130-width': <IconSingleBed />,
    'double-bed-131-150-width': <IconDoubleBed />,
    'king-size-bed-150-183-width': <IconDoubleBed />,
}

interface MappedIconTextProps {
  text: string
  facilityId?: string
}

export default function MappedIconText({ facilityId, text }: MappedIconTextProps) {
  if (!text) {
    return null
  }

  const icon = (facilityId && FACILITY_ICON_MAP[facilityId]) || <IconCheckCircle />

  return (
    <IconText icon={icon} size="s">
      {text}
    </IconText>
  )
}
